export default __webpack_public_path__ + "static/media/my-head-is-an-animal.f079d11b.jpg";